import styled from 'styled-components';

export const FieldWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;

  label {
    width: 30%;
  }

  &:first-of-type {
    align-items: baseline;
  }

  &:last-of-type {
    label {
      width: 23%;
    }
  }
`;
